import { useMutation } from "@tanstack/react-query";
import {
  postExceptionDay,
  updateCalendarName,
  updateExceptionDay,
  updateNominalDay
} from "PFCore/services/booking_config";
import { ExceptionDay, NominalDay } from "PFTypes/booking/booking_config";
import { MutationOptions } from "PFTypes/request_options";

type UpdateCalendarData = {
  calendarId: number;
  calendarName: string;
  nominalDays: NominalDay[];
  exceptionDays: ExceptionDay[];
};
type UseUpdateCalendar = {
  options?: MutationOptions<UpdateCalendarData>;
};

export const useUpdateCalendar = ({ options }: UseUpdateCalendar) =>
  useMutation({
    mutationFn: async ({ calendarId, calendarName, nominalDays, exceptionDays }: UpdateCalendarData) => {
      await updateCalendarName(calendarId, calendarName);
      await Promise.all(
        nominalDays.map((nominalDay) => {
          updateNominalDay(nominalDay);
        })
      );
      await Promise.all(
        exceptionDays.map((exceptionDay) =>
          exceptionDay.id ? updateExceptionDay(exceptionDay) : postExceptionDay(exceptionDay)
        )
      );
    },
    ...options
  });
